/**
 * Static catalogue bundle.
 *
 * Imports every locale JSON file at build time so the runtime can pre-load
 * a complete dictionary in tests and SSR; in the browser app, the bundler
 * (Vite) splits these JSON files into separate chunks via dynamic-import
 * boundaries (see `loadNamespace`). Tests prefer the eager bundle for
 * synchronous assertions.
 */
import { NAMESPACES, SUPPORTED_LOCALES } from './locales.js';
import accountsEn from './locales/en/accounts.json' with { type: 'json' };
import authEn from './locales/en/auth.json' with { type: 'json' };
import billingEn from './locales/en/billing.json' with { type: 'json' };
import businessesEn from './locales/en/businesses.json' with { type: 'json' };
import campaignsEn from './locales/en/campaigns.json' with { type: 'json' };
import commonEn from './locales/en/common.json' with { type: 'json' };
import errorsEn from './locales/en/errors.json' with { type: 'json' };
import extensionEn from './locales/en/extension.json' with { type: 'json' };
import ftuEn from './locales/en/ftu.json' with { type: 'json' };
import inboxEn from './locales/en/inbox.json' with { type: 'json' };
import leadsEn from './locales/en/leads.json' with { type: 'json' };
import notificationsEn from './locales/en/notifications.json' with { type: 'json' };
import onboardingEn from './locales/en/onboarding.json' with { type: 'json' };
import relancesEn from './locales/en/relances.json' with { type: 'json' };
import settingsEn from './locales/en/settings.json' with { type: 'json' };
import shellEn from './locales/en/shell.json' with { type: 'json' };
import voiceEn from './locales/en/voice.json' with { type: 'json' };
import accountsFr from './locales/fr/accounts.json' with { type: 'json' };
import authFr from './locales/fr/auth.json' with { type: 'json' };
import billingFr from './locales/fr/billing.json' with { type: 'json' };
import businessesFr from './locales/fr/businesses.json' with { type: 'json' };
import campaignsFr from './locales/fr/campaigns.json' with { type: 'json' };
import commonFr from './locales/fr/common.json' with { type: 'json' };
import errorsFr from './locales/fr/errors.json' with { type: 'json' };
import extensionFr from './locales/fr/extension.json' with { type: 'json' };
import ftuFr from './locales/fr/ftu.json' with { type: 'json' };
import inboxFr from './locales/fr/inbox.json' with { type: 'json' };
import leadsFr from './locales/fr/leads.json' with { type: 'json' };
import notificationsFr from './locales/fr/notifications.json' with { type: 'json' };
import onboardingFr from './locales/fr/onboarding.json' with { type: 'json' };
import relancesFr from './locales/fr/relances.json' with { type: 'json' };
import settingsFr from './locales/fr/settings.json' with { type: 'json' };
import shellFr from './locales/fr/shell.json' with { type: 'json' };
import voiceFr from './locales/fr/voice.json' with { type: 'json' };
const FR_BUNDLE = {
    common: commonFr,
    auth: authFr,
    inbox: inboxFr,
    voice: voiceFr,
    businesses: businessesFr,
    campaigns: campaignsFr,
    leads: leadsFr,
    relances: relancesFr,
    settings: settingsFr,
    billing: billingFr,
    onboarding: onboardingFr,
    ftu: ftuFr,
    extension: extensionFr,
    errors: errorsFr,
    shell: shellFr,
    accounts: accountsFr,
    notifications: notificationsFr,
};
const EN_BUNDLE = {
    common: commonEn,
    auth: authEn,
    inbox: inboxEn,
    voice: voiceEn,
    businesses: businessesEn,
    campaigns: campaignsEn,
    leads: leadsEn,
    relances: relancesEn,
    settings: settingsEn,
    billing: billingEn,
    onboarding: onboardingEn,
    ftu: ftuEn,
    extension: extensionEn,
    errors: errorsEn,
    shell: shellEn,
    accounts: accountsEn,
    notifications: notificationsEn,
};
/** Eager catalogue table, keyed by `[locale][namespace]`. */
export const CATALOGUES = {
    fr: FR_BUNDLE,
    en: EN_BUNDLE,
};
/**
 * Async catalogue loader — mirrors the dynamic-import API surface that
 * `I18nProvider` uses on the client. In Vite/webpack the `import()` calls
 * resolve to per-namespace chunks; in tests they short-circuit to the eager
 * bundle so we don't need a worker.
 */
export async function loadNamespace(locale, namespace) {
    const bundle = CATALOGUES[locale][namespace];
    return Promise.resolve(bundle);
}
/**
 * Bulk loader used by the provider on first mount.
 */
export async function loadAllNamespaces(locale) {
    const entries = await Promise.all(NAMESPACES.map(async (ns) => [ns, await loadNamespace(locale, ns)]));
    return Object.fromEntries(entries);
}
/** Re-exports the locale set for convenience. */
export const SUPPORTED_LOCALES_LIST = SUPPORTED_LOCALES;
//# sourceMappingURL=catalogues.js.map